import { StyleSheet } from '@react-pdf/renderer';

export const Styles = StyleSheet.create({
  container: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    height: '95%',
  },
  headerTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 10,
  },
  rowHeader: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 5px',
    padding: '3px',
    backgroundColor: '#f0f0f0',
    color: '#000',
  },
  row: {
    width: '98%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0px 5px',
    padding: '3px',
  },
  columnHeader: {
    flex: 1,
    fontSize: 10,
    fontWeight: 700,
  },
  column: {
    flex: 1,
    fontSize: 8,
  },
  columnTotal: {
    fontSize: 11,
    fontWeight: 700,
  },
});
